import Vue from "vue";
import App from "./App.vue";
import {
  Alert,
  Button,
  Descriptions,
  Divider,
  Form,
  Icon,
  Input,
  Layout,
  Menu,
  message,
  Popover,
  Radio,
  Result,
  Select,
  Skeleton,
  Space,
  Spin,
  Switch,
  Table,
  Tabs,
  Tag,
  DatePicker,

  Modal
} from "ant-design-vue";
import router from "./router";
import store from "./store/store";

Vue.config.productionTip = false;

Vue.use(Alert);
Vue.use(Button);
Vue.use(Descriptions);
Vue.use(Divider);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Radio.Group);
Vue.use(Result);
Vue.use(Select);
Vue.use(Skeleton);
Vue.use(Space);
Vue.use(Spin);
Vue.use(Switch);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(DatePicker);
Vue.use(Modal);

Vue.prototype.$message = message;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
